import assetPath from '/opt/actions-runner/_work/crate/crate/packages/dream-machine/search-bar/src/components/assets/pride-brackground-1920.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')